import { Container, Box } from '@mui/material';
import React from 'react';
import SecurityForm from '../../../components/security-form';

const SecurityView = ({
  onNavigateBack,
  onSuccessfulPasswordChange,
}: {
  onNavigateBack: () => void;
  onSuccessfulPasswordChange?: () => void;
}) => (
  <Container maxWidth="md">
    <Box
      sx={{
        pt: 3.75,
        pb: 12,
      }}
    >
      <SecurityForm
        onNavigateBack={onNavigateBack}
        onSuccessfulPasswordChange={onSuccessfulPasswordChange}
      />
    </Box>
  </Container>
);

export default SecurityView;
